import { render } from "./ReceivedSendoutsWoundPanelSelectedTests.vue?vue&type=template&id=f24c1b46"
import script from "./ReceivedSendoutsWoundPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./ReceivedSendoutsWoundPanelSelectedTests.vue?vue&type=script&lang=js"

import "./ReceivedSendoutsWoundPanelSelectedTests.vue?vue&type=style&index=0&id=f24c1b46&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/ReceivedSendoutsWoundPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f24c1b46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f24c1b46', __exports__)) {
    console.log('reload')
    api.reload('f24c1b46', __exports__)
  }
  
  module.hot.accept("./ReceivedSendoutsWoundPanelSelectedTests.vue?vue&type=template&id=f24c1b46", () => {
    console.log('re-render')
    api.rerender('f24c1b46', render)
  })

}


export default __exports__